import TextField from '@mui/material/TextField'

export default function ListFilter({ value, fields, onChange }) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    >
      <div style={{ flex: 1 }} />
      {fields.map(x => (
        <TextField
          key={x.id}
          label={x.name}
          variant="outlined"
          select
          value={value[x.id]}
          size="small"
          SelectProps={{ native: true }}
          onChange={e => onChange(x.id, e.target.value)}
          sx={{ ml: 2 }}
          disabled={x.disabled}
        >
          {!x.excludeAllOption && <option value="*">すべて</option>}
          {x.options.map(x => {
            if (typeof x === 'string') {
              return <option key={x}>{x}</option>
            } else {
              return (
                <option key={x.value} value={x.value}>
                  {x.label}
                </option>
              )
            }
          })}
        </TextField>
      ))}
    </div>
  )
}
